export default __webpack_public_path__ + "static/strategy_analysis_img_3-b840f795bf63ff519f5dcf84ac8cdd78.png";